import { InsightApi } from 'api/InsightApi';
import { apiClient } from 'container/apiClient';
import { insightMapper } from 'container/insightMapper';

export const insightApi = new InsightApi(apiClient, insightMapper);
